// extracted by mini-css-extract-plugin
export default {"goBackContainer":"GoBackBar_goBackContainer--XQO","backArrow":"GoBackBar_backArrow--FP3"};